import { render, staticRenderFns } from "./Resultado.vue?vue&type=template&id=f4c444e0&scoped=true"
import script from "./Resultado.vue?vue&type=script&lang=js"
export * from "./Resultado.vue?vue&type=script&lang=js"
import style0 from "./Resultado.vue?vue&type=style&index=0&id=f4c444e0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c444e0",
  null
  
)

export default component.exports